import { Typography } from "@mui/material";

type GeometryInfoProps = {
  geometry?: string;
};

export default function GeometryInfo({ geometry }: GeometryInfoProps) {
  let label: string | null = null;
  if (geometry) {
    label = "Custom geometry";
    try {
      label = `${JSON.parse(geometry).type} defined`;
    } catch {}
  }

  return (
    <Typography variant={"body1"} color={label ? "grey.500" : "grey.400"}>
      {label ? (
        <>
          <strong>Geometry:</strong> {label}
        </>
      ) : (
        "Edit GeoJSON below or use external tools"
      )}
    </Typography>
  );
}
